/** Participation is independent from existing subject categories. No legacy posts are rewritten. */
export const COMMUNITY_PURPOSES = [
  {
    id: "question",
    label: "도움 요청",
    tag: "질문",
    title: "함께 풀어볼까요?",
    description: "수업·학급·업무에서 막힌 순간",
    placeholder: "예: 모둠 활동에 참여하지 않는 학생, 어떻게 도와주시나요?",
    guidance:
      "대상 학년 · 현재 상황 · 이미 시도한 방법을 알려주시면 답하기 쉬워요.",
    template:
      "<p><strong>어떤 상황인가요?</strong></p><p><br></p><p><strong>어떤 방법을 시도했나요?</strong></p><p><br></p><p><strong>어떤 도움이 필요한가요?</strong></p><p><br></p>",
  },
  {
    id: "resource",
    label: "자료 나눔",
    tag: "자료나눔",
    title: "함께 쓰면 더 좋아요",
    description: "직접 쓴 자료와 유용한 방법",
    placeholder: "예: 중1 첫 수업에 사용한 자기소개 활동지 나눠요",
    guidance: "대상 학년 · 활용 방법 · 수정 가능한지 함께 적어주세요.",
    template:
      "<p><strong>누가, 언제 쓰면 좋을까요?</strong></p><p><br></p><p><strong>이렇게 활용했어요</strong></p><p><br></p><p><strong>파일·링크와 이용 범위</strong></p><p><br></p>",
  },
  {
    id: "story",
    label: "경험·공감",
    tag: "경험공감",
    title: "선생님의 하루를 들려주세요",
    description: "작은 성공, 고민, 동료의 한마디",
    placeholder: "예: 오늘 아이의 한마디에 다시 힘을 얻었어요",
    guidance: "완성된 노하우가 아니어도 좋아요. 오늘의 경험 하나면 충분해요.",
    template:
      "<p><strong>오늘 나누고 싶은 이야기</strong></p><p><br></p><p><strong>선생님들은 어떠셨나요?</strong></p><p><br></p>",
  },
  {
    id: "showcase",
    label: "만든 것 소개",
    tag: "창작소개",
    title: "선생님의 아이디어를 만나보세요",
    description: "직접 만든 책·웹사이트·수업 도구",
    placeholder: "예: 제가 만든 모둠 활동 타이머, 사용해 보시고 의견 주세요",
    guidance:
      "직접 만든 분이라면 밝혀주세요. 대상 · 활용 방법 · 무료/유료 여부 · 받고 싶은 의견을 함께 적어주세요.",
    template:
      "<p><strong>제가 만든 것을 소개해요</strong></p><p><br></p><p><strong>이런 선생님께 도움이 돼요</strong></p><p><br></p><p><strong>사용 방법과 링크 (무료/유료 안내)</strong></p><p><br></p><p><strong>이런 의견을 듣고 싶어요</strong></p><p><br></p>",
  },
] as const;
export type CommunityPurpose = (typeof COMMUNITY_PURPOSES)[number]["id"];
export function readCommunityPurpose(value: unknown): CommunityPurpose | "" {
  return COMMUNITY_PURPOSES.some((p) => p.id === value)
    ? (value as CommunityPurpose)
    : "";
}
export function purposeFromTags(tags?: string | null): CommunityPurpose | "" {
  const words = (tags || "").split(",").map((t) => t.trim().replace(/^#/, ""));
  return (
    COMMUNITY_PURPOSES.find((p) => words.includes(p.tag))?.id ||
    (words.includes("교사의새책") ? "showcase" : "")
  );
}
export function withPurposeTag(
  tags: string,
  purpose: CommunityPurpose | "",
): string {
  if (!purpose) return tags;
  const others = tags
    .split(",")
    .map((t) => t.trim())
    .filter(
      (t) =>
        t && !COMMUNITY_PURPOSES.some((p) => p.tag === t.replace(/^#/, "")),
    );
  return [
    COMMUNITY_PURPOSES.find((p) => p.id === purpose)!.tag,
    ...others,
  ].join(",");
}
/** Only trusted, fixed expressions enter PostgREST's OR syntax. */
export const COMMUNITY_PURPOSE_FILTERS: Record<CommunityPurpose, string> = {
  showcase:
    "tags.ilike.%창작소개%,subcategory_name.in.(바이브코딩,책,도서),tags.ilike.%교사의새책%",
  question: "tags.ilike.%질문%,subcategory_name.in.(질문,질문답변,Q&A)",
  resource:
    "tags.ilike.%자료나눔%,subcategory_name.in.(자료,자료공유,자료나눔),and(file_upload.not.is.null,file_upload.neq.)",
  story:
    "tags.ilike.%경험공감%,subcategory_name.in.(이야기,일상,자유,자유게시판)",
};
